import {createSlice} from '@reduxjs/toolkit';
import {FilteredPayloadAction, reducerUtils} from '@wallaby-ui/core';

import {CHART_REDUCER_STATE_ID} from './chart_constants';
import {ChartReportConfig} from 'src/js/model/reports_config';

// TODO: type it with types/plotly.js + out config
export interface ChartState {
  chartConfig: ChartReportConfig | undefined;
}

const initialState: ChartState = {
  chartConfig: undefined,
};

export const chartSlice = createSlice({
  name: CHART_REDUCER_STATE_ID,
  initialState,
  reducers: {
    setChartConfig: {
      reducer(state, action: FilteredPayloadAction<ChartReportConfig>) {
        state.chartConfig = action.payload;
      },
      prepare: reducerUtils.prepareWithStateIdFactory<ChartReportConfig>(),
    },
  },
});
